const {
  REACT_APP_AUTHENTICATION_METHOD
} = process.env

export const authType = (type) => REACT_APP_AUTHENTICATION_METHOD === type


// WEBPACK FOOTER //
// ./src/utils/auth.js